import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../../services/directory.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {AbstractDetailedView} from '../abstract-detailed-view';
import {ConstantsService} from '../../../../services/constants.service';
import {PhoneTransformer} from '../../../../services/transformer.service';
import { environment } from 'environments/environment';
import {Response, Headers, RequestOptions} from '@angular/http';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'vendor-view',
    templateUrl: './vendor-view.component.html',
    styleUrls: ['vendor-view.component.scss']
})
export class VendorViewComponent extends AbstractDetailedView implements OnInit {
    title = 'Vendor';
    paymentMethods: Array<any> = [];
    categories: Array<any> = [];
    navPosition = 'profile';
    categoriesMultiselectSettings = {
        singleSelection: false,
        text: 'Select Categories',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        scrollable: true,
        enableSearchFilter: true,
        classes: 'with-filter'
    };
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Payment Methods',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        scrollable: true,
    };
    productsCopy = null;
    disabledFileInput = false;
    spinnerShow = false;

    constructor(public directoryService: DirectoryService,
                public api: ApiClientService) {
        super(directoryService, api);
    }

    initData(data) {
        if (!data) return;
        this.data = data;
        this.setEditModeForAll(false);
        this.getPaymentMethods();
        this.getCategories();
    }

    update(form: NgForm, formField) {
        if (!form.valid) {
            toastr.warning('Sent data is not valid.');
            return;
        }
        const data: any = {};

        if(formField == 'numberOfEmployees') {
            data.minNumberOfEmployees = form.value.minNumberOfEmployees;
            data.maxNumberOfEmployees = form.value.maxNumberOfEmployees;
        } else if(formField == 'paymentMethods' || formField == 'categories')
            data[formField] = form.value[formField].map(i => (i.id));
        else
            data[formField] = form.value[formField];

        this.patch(form.value.id, data);
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }

    patch(residentId: number, data): void {
        const url = `${this.directoryService.getUrl('patch')}${residentId}.json`;
        this.api.patch('domainVendors', url, data).subscribe(
            (res)   => this.updateView(this.title + ' successfully updated', false),
            (error) => this.api.errorHandler(error, 'Edit failed')
        );
    }

    remove(id: number): void {
        swal(ConstantsService.getSwalConfig('Delete ' + this.title),
            () => {
                const url = this.directoryService.getUrl('remove');
                this.api.remove('domainVendors', url + id).subscribe(
                    ()      => this.updateView(this.title + ' has been deleted.'),
                    (error) => this.api.errorHandler(error, 'Delete data failed')
                );
            }
        );
    }

    public getPaymentMethods() {
        if(this.paymentMethods.length > 0) return;
        const url = `/v1/admin/payment_methods?per-page=1000`;
        this.api.get('domainVendors', url).subscribe(
            res => {
                this.paymentMethods = [];
                const body = JSON.parse(res._body);
                this.paymentMethods = body.entities.map(item => ({...item, itemName: item.name}));
            },
            error => this.api.errorHandler(error, 'Failed to get Payment Methods')
        );
    }

    public getCategories() {
        if(this.categories.length > 0) return;
        const url = `/v1/admin/categories?per-page=1000`;
        this.api.get('domainVendors', url).subscribe(
            res => {
                this.categories = [];
                const body = JSON.parse(res._body);
                this.categories = body.entities.map(item => ({...item, itemName: item.name}));
            },
            error => this.api.errorHandler(error, 'Failed to get Payment Methods')
        );
    }

    addToFavorites() {
        const data = {
            vendor: this.data.id,
            favorite: !(this.data.userCompany && this.data.userCompany.favorite)
        };
        const url = '/v1/company_vendors';
        this.api.post('domainVendors', url, data).subscribe(
            res   => this.updateView(this.title + ' successfully updated', false),
            error => this.api.errorHandler(error, 'Edit failed')
        );
    }

    userIsSuperAdmin() {
        const userType = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).userType : '';
        return userType == 'super_admin';
    }

    public getPhone() {
        if(this.data.phones.length > 0) {
            let index = 0;
            const matchIndex = this.data.phones.findIndex(item => item.isPrimaryPhone);
            if (matchIndex != -1)
                index = matchIndex;
            if (this.data.phones[index].phone.match('^[0-9]+$'))
                return PhoneTransformer.stringToPhone(this.data.phones[index].phone);
            else
                return this.data.phones[index].phone.substr();
        } else
            return '';
    }

    getItemAddressString(item) {
        if(item) {
            return item.address +
                (item.city ? (', ' + item.city) : '') +
                (item.postalCode ? (', ' + item.postalCode) : '') +
                (item.state ? (', ' + item.state) : '') +
                (item.country ? (', ' + this.directoryService.countries.find(c => c.id == item.country.id).countryName) : '');
        } else
            return '';
    }

    addNewProduct(index) {
        this.data.products.splice(index + 1, 0, '');
    }

    removeProduct(index) {
        this.data.products.splice(index, 1);
    }

    submitProductsChanges() {
        const valid = this.data.products.findIndex(p => !p) == -1;
        if (valid) {
            this.setEditModeForAll(false);
            this.patch(this.data.id, {products: this.data.products});
        } else {
            toastr.warning('All fields must filled to be submitted');
            return;
        }
    }

    editProductChanges() {
        this.productsCopy = JSON.parse(JSON.stringify(this.data.products));
        this.setEditModeFor(this.data, 'products', true);
    }

    revertProductsChanges() {
        this.data.products = JSON.parse(JSON.stringify(this.productsCopy));
        this.productsCopy = null;
        this.setEditModeFor(this.data, 'products', false);
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    applyChanges(item, form, formField) {
        if(formField != 'corporations')
            super.applyChanges(item, form, formField);
        else {
            if (form.valid)
                this.setEditModeForAll(false);
            const data = {
                corporations: form.value.corporations.map(c => ({bdId: c.bdId ? c.bdId : c.id, name: c.name, number: c.name}))
            };
            this.patch(form.value.id, data);
        }
    }

    actionButtonIsNotAvailable() {
        return !(this.data.id && this.data.isCanDelete);
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 10000000) {
            toastr.warning('Maximum attachment size is 10MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token   = this.api.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.spinnerShow = true;
        this.disabledFileInput = true;
        this.api.http.post(`${environment.domainServiceRequest}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                this.data.logo = res.path;
                this.patch(this.data.id, {logo: res.path});
                this.spinnerShow = false;
                this.disabledFileInput = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.spinnerShow = false;
                this.disabledFileInput = false;
            }
        );
    }

    clickFileUploadButton() {
        document.getElementById('add-attachment-btn').click();
    }

    removeLogo() {
        this.patch(this.data.id, {logo: null});
    }
}






// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/vendor-view/vendor-view.component.ts